<template>
  <v-container
    id="Orden_trabajo"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <base-material-card
          icon="mdi-clipboard-text"
          title="Ordenes de trabajo "
          color="primary"
        >
          <v-spacer />
          <v-col
            md="4"
            offset-md="8"
          >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            />
          </v-col>
          <v-data-table
            :headers="tabla_headers"
            :items="tabla_items"
            :search="search"
          >
            <template v-slot:item.actions="{ item }">
              <div class="text-truncate">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="mr-2"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      @click="showEditDialog(item), cargaClientes()"
                    >
                      mdi-pencil
                    </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="pink"
                      class="mr-2"
                      v-bind="attrs"
                      v-on="on"
                      @click="deleteItem(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="mr-2"
                      color="blue"
                      v-bind="attrs"
                      v-on="on"
                      @click="ReportItem(item.id)"
                    >
                      mdi-file-document
                    </v-icon>
                  </template>
                  <span>Generar orden</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="mr-2"
                      color="green"
                      v-bind="attrs"
                      v-on="on"
                      @click="nota(item.id)"
                    >
                      mdi-file-document
                    </v-icon>
                  </template>
                  <span>Generar nota de entrega</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
          <v-dialog
            v-model="dialog"
            persistent
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on }">
              <div class="d-flex">
                <v-btn
                  color="primary"
                  dark
                  v-on="on"
                >
                  Nueva orden
                </v-btn>
              </div>
            </template>
            <v-card>
              <v-form ref="form">
                <v-toolbar
                  dark
                  color="primary"
                >
                  <v-btn
                    icon
                    dark
                    @click="cerrarDialogo"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>
                    <span
                      v-if="editedItem.id"
                    >Editar orden de trabajo número: {{ editedItem.id }}
                    </span>
                    <span v-else>Crear Nueva Orden</span>
                  </v-toolbar-title>
                  <v-spacer />
                  <v-toolbar-items>
                    <v-btn
                      text
                      @click="saveItem(editedItem)"
                    >
                      Guardar
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="4"
                    >
                      <v-select
                        v-model="editedItem.cliente"
                        :items="clientes"
                        item-text="nombre"
                        item-value="id"
                        label="Seleccione un cliente"
                        hint="Cliente"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                    >
                      <v-text-field
                        v-model="editedItem.placa"
                        label="Placa del vehiculo"
                        hint="Placa"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                    >
                      <v-text-field
                        v-model="editedItem.kilometraje"
                        label="Kilometraje del vehiculo"
                        hint="Kilometraje"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="3"
                    >
                      <v-select
                        v-model="editedItem.modelovehiculo"
                        :items="modelo"
                        item-text="descripcion"
                        item-value="id"
                        label="Seleccione un modelo"
                        hint="Modelo"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                    >
                      <v-select
                        v-model="editedItem.marcavehiculo"
                        :items="marca"
                        item-text="descripcion"
                        item-value="id"
                        label="Seleccione una marca"
                        hint="Modelo"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                    >
                      <v-select
                        v-model="editedItem.añovehiculo"
                        :items="años.año"
                        item-text="año"
                        item-value="año"
                        label="Seleccione un año"
                        hint="Modelo"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                    >
                      <v-text-field
                        v-model="editedItem.precio_manodeobra"
                        label="Precio de la mano de obra"
                        hint="Precio de mano de obra"
                      />
                    </v-col>
                    <v-col
                      class="d-flex"
                      cols="12"
                      sm="3"
                    >
                      <v-select
                        v-if="editedItem.id"
                        v-model="editedItem.estatus"
                        label="Estatus"
                        :items="lista_estatus"
                        item-text="text"
                        item-value="value"
                        required
                      />
                    </v-col>
                  </v-row>
                  <v-spacer />
                  <v-row>
                    <v-col>
                      <base-material-card
                        icon="mdi-plus"
                        class="px-5 py-3"
                        color="primary"
                        title="Agregar Productos"
                      >
                        <v-form
                          lazy-validation
                          @submit.prevent="agregarComponente"
                        >
                          <v-select
                            v-model="productos.producto"
                            :items="producto"
                            item-text="descripcion"
                            item-value="id"
                            label="Productos:"
                          />
                          <v-text-field
                            v-model="productos.cantidad"
                            label="Cantidad"
                            type="number"
                            hint="cantidad de este producto"
                            required
                          />
                          <v-text-field
                            v-model="productos.precio_compra"
                            label="Precio Compra"
                            type="number"
                            hint="Precio de compra"
                            required
                          />
                          <v-text-field
                            v-model="productos.precio_venta"
                            label="Precio Venta"
                            type="number"
                            hint="Precio de Venta"
                            required
                          />
                          <v-btn
                            color="primary"
                            type="submit"
                          >
                            Agregar
                          </v-btn>
                        </v-form>
                      </base-material-card>
                    </v-col>
                    <v-col>
                      <base-material-card
                        icon="mdi-format-list-bulleted"
                        color="primary"
                        class="px-5 py-3"
                        title="Productos asociados a esta orden"
                      >
                        <v-data-table
                          :headers="tabla_componentes_header"
                          :items="tabla_componentes_items"
                          hide-default-footer
                        >
                          <template v-slot:item.actions="{ item }">
                            <div class="text-truncate">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    class="mr-2"
                                    color="primary"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="showEditDialog2(item)"
                                  >
                                    mdi-pencil
                                  </v-icon>
                                </template>
                                <span>Editar</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    color="pink"
                                    class="mr-2"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="deleteComponente(item)"
                                  >
                                    mdi-delete
                                  </v-icon>
                                </template>
                                <span>Eliminar</span>
                              </v-tooltip>
                            </div>
                          </template>
                        </v-data-table>
                      </base-material-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-form>
            </v-card>
            <v-dialog
              v-model="dialog2"
              transition="dialog-bottom-transition"
              max-width="600"
            >
              <v-card>
                <v-card-title>
                  Editar cantidad
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    v-model="editedItem2.cantidad"
                    label="Cantidad"
                    type="number"
                    hint="cantidad en kg para crear 1 tonelada de producto"
                    required
                  />
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="danger"
                    @click="dialog2 = false"
                  >
                    Cerrar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-dialog>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'PaginaProductos',
    data () {
      return {
        search: '',
        años: [],
        rules: {
          nombre_producto: [v => !!v || 'El valor es requerido'],
          codigo_producto: [v => !!v || 'El valor es requerido'],
          numerico: [
            v => !!v || 'El valor es requerido',
            v => (v && v > 0) || 'Debe ser mayor a 0',
          ],
          nombre_componente: [
            v => !!v || 'El valor es requerido',
            v => (v && v.length() < 300) || 'Debe ser mayor a 300 caracteres',
          ],
          codigo_componente: [
            v => !!v || 'El valor es requerido',
            v => (v && v.length() < 30) || 'Debe ser mayor a 30 caracteres',
          ],
        },
        lista_estatus: [
          {
            value: 'A',
            text: 'Activa',
          },
          {
            value: 'L',
            text: 'Listo',
          },
        ],
        tabla_headers: [
          {
            text: 'Numero de orden',
            value: 'id',
          },
          {
            text: 'Cliente',
            value: 'nombre_cliente',
          },
          {
            text: 'Modelo',
            value: 'nombre_modelo',
          },
          {
            text: 'Marca',
            value: 'nombre_marca',
          },
          {
            text: 'Año del vehiculo',
            value: 'añovehiculo',
          },
          {
            text: 'Placa',
            value: 'placa',
          },
          {
            text: 'Kilometraje',
            value: 'kilometraje',
          },
          {
            text: 'Estatus',
            value: 'estatus',
          },
          {
            text: 'Precio de la mano de obra',
            value: 'precio_manodeobra',
          },
          {
            text: 'Fecha de la orden',
            value: 'fecha',
          },
          {
            text: 'Acciones',
            value: 'actions',
            sortable: false,
          },
        ],
        tabla_items: [],
        tabla_componentes_header: [
          {
            text: 'Producto',
            value: 'descripcion',
          },
          {
            text: 'Cantidad',
            value: 'cantidad',
          },
          {
            text: 'Precio compra',
            value: 'precio_compra',
          },
          {
            text: 'Precio venta',
            value: 'precio_venta',
          },
          {
            text: 'Acciones',
            value: 'actions',
            sortable: false,
          },
        ],
        tabla_componentes_items: [],
        clientes: [],
        modelo: [],
        marca: [],
        productos: {
        },
        producto: [],
        dialog: false,
        dialog2: false,
        editedItem: {},
        editedItem2: {},
        itemcopy: {},
        data_draggable: {},
      }
    },
    mounted () {
      this.loadItems()
      this.cargaClientes()
      this.cargamodelo()
      this.cargamarca()
      this.cargaproducto()
      this.cargaaños()
    },
    methods: {
      complete (index) {
        this.list[index] = !this.list[index]
      },
      cargadetalle (idorden) {
        this.tabla_componentes_items = []
        var protocol = window.location.protocol
        axios
          .get(
            protocol +
              '//' +
              window.location.hostname +
              ':' +
              this.$session.get('puerto') +
              'detalleorden/?ordendetrabajo=' +
              idorden,
            { headers: { Authorization: 'token ' + this.$session.get('token') } },
          )
          .then(response => {
            this.tabla_componentes_items = response.data.map(item => {
              return {
                id: item.producto,
                descripcion: item.nombre_producto,
                cantidad: item.cantidad_producto,
                precio_compra: item.precio_compra,
                precio_venta: item.precio_venta,
              }
            })
          })
          .catch(error => {
            console.log(error)
          })
      },
      showEditDialog (item) {
        this.editedItem = item || {}
        this.dialog = !this.dialog
        if (this.editedItem) {
          this.cargadetalle(item.id)
        }
      },
      ReportItem (idOrden) {
        var protocol = window.location.protocol
        var win = window.open(protocol + '//' + window.location.hostname + ':' + this.$session.get('puerto') + 'dpdf/' + idOrden, '_blank')
        win.focus()
      },
      nota (idOrden) {
        var protocol = window.location.protocol
        var win = window.open(protocol + '//' + window.location.hostname + ':' + this.$session.get('puerto') + 'nota_entrega/' + idOrden, '_blank')
        win.focus()
      },
      showEditDialog2 (item) {
        this.editedItem2 = item || {}
        this.dialog2 = !this.dialog2
      },
      cargaClientes () {
        this.clientes = []
        axios
          .get(
            window.location.protocol +
              '//' +
              window.location.hostname +
              ':' +
              this.$session.get('puerto') +
              'Clientes/',
            { headers: { Authorization: 'token ' + this.$session.get('token') } },
          )
          .then(response => {
            this.clientes = response.data
          })
          .catch(error => {
            console.log(error)
          })
      },
      cargaaños () {
        this.años = []
        axios
          .get(
            window.location.protocol +
              '//' +
              window.location.hostname +
              ':' +
              this.$session.get('puerto') +
              'anios/',
            { headers: { Authorization: 'token ' + this.$session.get('token') } },
          )
          .then(response => {
            this.años = response.data
          })
          .catch(error => {
            console.log(error)
          })
      },
      cargamodelo () {
        this.modelo = []
        axios
          .get(
            window.location.protocol +
              '//' +
              window.location.hostname +
              ':' +
              this.$session.get('puerto') +
              'Modelo/',
            { headers: { Authorization: 'token ' + this.$session.get('token') } },
          )
          .then(response => {
            this.modelo = response.data
          })
          .catch(error => {
            console.log(error)
          })
      },
      cargamarca () {
        this.marca = []
        axios
          .get(
            window.location.protocol +
              '//' +
              window.location.hostname +
              ':' +
              this.$session.get('puerto') +
              'Marca/',
            { headers: { Authorization: 'token ' + this.$session.get('token') } },
          )
          .then(response => {
            this.marca = response.data
          })
          .catch(error => {
            console.log(error)
          })
      },
      cargaproducto () {
        this.producto = []
        axios
          .get(
            window.location.protocol +
              '//' +
              window.location.hostname +
              ':' +
              this.$session.get('puerto') +
              'Categoriaproducto/',
            { headers: { Authorization: 'token ' + this.$session.get('token') } },
          )
          .then(response => {
            this.producto = response.data
          })
          .catch(error => {
            console.log(error)
          })
      },
      agregarComponente () {
        axios
          .get(
            window.location.protocol +
              '//' +
              window.location.hostname +
              ':' +
              this.$session.get('puerto') +
              'Categoriaproducto/' +
              this.productos.producto,
            { headers: { Authorization: 'token ' + this.$session.get('token') } },
          )
          .then(response => {
            this.productos.descripcion = response.data.descripcion
            this.productos.id = response.data.id
            this.tabla_componentes_items.push(this.productos)
            this.productos = {}
          })
          .catch(error => {
            console.log(error)
          })
      },
      loadItems () {
        this.tabla_items = []
        axios
          .get(
            window.location.protocol +
              '//' +
              window.location.hostname +
              ':' +
              this.$session.get('puerto') +
              'orden/',
            { headers: { Authorization: 'token ' + this.$session.get('token') } },
          )
          .then(response => {
            this.tabla_items = response.data.map(item => {
              return {
                id: item.id,
                nombre_cliente: item.nombre_cliente,
                cliente: item.cliente,
                modelovehiculo: item.modelovehiculo,
                marcavehiculo: item.marcavehiculo,
                nombre_modelo: item.nombre_modelo,
                nombre_marca: item.nombre_marca,
                añovehiculo: item.añovehiculo,
                placa: item.placa,
                kilometraje: item.kilometraje,
                estatus: item.estatus,
                precio_manodeobra: item.precio_manodeobra,
                fecha: item.fecha,
                ...item.fields,
              }
            })
          })
          .catch(error => {
            console.log(error)
          })
      },
      saveItem (item) {
        const tablaComponentesItems = this.tabla_componentes_items
        let method = 'post'
        let url =
          window.location.protocol +
          '//' +
          window.location.hostname +
          ':' +
          this.$session.get('puerto') +
          'orden/'
        const id = item.id
        if (id) {
          method = 'put'
          url =
            window.location.protocol +
            '//' +
            window.location.hostname +
            ':' +
            this.$session.get('puerto') +
            'aorden/' +
            id +
            ''
          axios[method](
            url,
            {
              item,
              tablaComponentesItems,
            },
            {
              headers: {
                Authorization: 'token ' + this.$session.get('token'),
                'Content-Type': 'application/json',
              },
            },
          ).then(response => {
            if (response.data) {
              this.loadItems()
            }
            this.cerrarDialogo()
          })
        } else {
          axios[method](url, item, {
            headers: {
              Authorization: 'token ' + this.$session.get('token'),
              'Content-Type': 'application/json',
            },
          }).then(response => {
            if (response.data) {
              this.editedItem.id = response.data.id
              this.saveItem(this.editedItem)
              this.tabla_items.push(response.data)
            }
          })
        }
      },
      cerrarDialogo: function () {
        this.editedItem = {}
        this.tabla_componentes_items = []
        this.dialog = false
      },
      deleteComponente: function (componente) {
        this.$swal({
          text: 'Esta seguro de eliminar el registro?',
          showConfirmButton: true,
          showCloseButton: true,
          showCancelButton: true,
          icon: 'warning',
        }).then(result => {
          if (result.isConfirmed) {
            var i = this.tabla_componentes_items.indexOf(componente)
            if (i !== -1) {
              this.tabla_componentes_items.splice(i, 1)
            }
            this.$swal('Registro eliminado', '', 'info')
          }
        })
      },
      deleteItem (item) {
        this.$swal({
          text: 'Esta seguro de eliminar el registro?',
          showConfirmButton: true,
          showCloseButton: true,
          showCancelButton: true,
          icon: 'warning',
        }).then(result => {
          if (result.isConfirmed) {
            axios
              .delete(
                window.location.protocol +
                  '//' +
                  window.location.hostname +
                  ':' +
                  this.$session.get('puerto') +
                  'dproducto/' +
                  item.id +
                  '',
                {
                  headers: { Authorization: 'token ' + this.$session.get('token') },
                },
              )
              .then(response => {
                this.$swal('Registro eliminado', '', 'info')
                this.tabla_items.splice(
                  this.tabla_items.findIndex(e => e.id === item.id),
                  1,
                )
              })
              .catch(error => {
                this.$swal('Se genero un error', '', 'error')
                console.log(error)
              })
          }
        })
      },
    },
  }
</script>
